import axios from '@service'
import { GET_APPLICATION_CONTENT_DATA } from './api'
import { HTTP_ERR_SUCCESS } from '@constant/api_status'
import { ERROR_DEFAULT_HTTP_REQUEST_FAIL } from '@constant/error'

// 项目信息
export default async function getApplicationContentDataService(payload = {}, config = {}) {
    const param = {
        ...GET_APPLICATION_CONTENT_DATA,
        ...config,
        params: payload
    }

    const { data } = await axios(param)

    if (data.code === HTTP_ERR_SUCCESS) {
        return data.result || {}
    } else {
        throw new Error(data.errorMessage || ERROR_DEFAULT_HTTP_REQUEST_FAIL)
    }
}
